<template>
	<div class='page'>
		<!--下拉刷新-->
		<mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh"/>
		
		<!--顶部标题-->
    <pageTitle title='常住人员管理' @rightHandler='open' :showRight='true' rightTitle='新增'/>
		
		<!--入住信息列表-->
		<div class="plist">
			<div class="pitem" v-for='(checkIn,index) in checkInList'>
				<div class="left" @click="edit(checkIn)">
					<img src='../../../static/user/headimg.png' />
					<div class="msg">
						<div class="title">{{checkIn.Name}}</div>
						<div class="phone">手机：{{checkIn.MobilePhone}}</div>
					</div>
				</div>
				<!--个人中心，允许删除-->
				<div v-if='fromMakeOrder != true' class="right" >
					<span  @click.stop="delHandler(checkIn.Id)">删除</span>	
				</div>
				<!--提交订单进来，允许选择-->
				<div v-else class="right"  @click="choose(index)">
					<img v-if='checkIn.selected' src="../../../static/user/InvoYes.png"/>
					<img v-else src="../../../static/user/InvoNo.png"/>
				</div>
			</div>
		</div>

		<!--加载图和空白页-->
    <loadListTail mainTitle='您暂无常住信息' mainIcon='noDetail' :noMore='loadState.stop' :isLoading='loadState.loading' :overZero='checkInList.length > 0'  />
    <div class='loading' v-if='loadState.loading'>
      <img src="../../../static/LoadingBest.gif" />
    </div>

		<!--添加对话框-->
		<mu-dialog dialogClass="dia_passenger" actionsContainerClass='d_btns' :open="dialog" title="新增常住人" titleClass="d_title" @close="close">
			<div class="u_item">
				<label>姓名</label>
				<input v-model="name" type="text" placeholder="请输入姓名"/>
			</div>
			<div class="u_item">
				<label>手机</label>
				<input v-model="phone" type="text" placeholder="请输入手机号"/>
			</div>
			<div class="u_item">
				<label>邮箱</label>
				<input v-model="email" type="text" placeholder="请输入邮箱"/>
			</div>
			<div class="btns">
				<mu-raised-button label="取消" @click="close" class="left"/>
				<mu-raised-button label="确定" @click="InsertCheckIn" class="right"/>
			</div>
		</mu-dialog>

		<!--删除提示对话框-->
		<mu-dialog :open="hint" title="" @close="hint=false">
      <div style="color:#666666">
        尊敬的客户，您确定删除该信息吗？
      </div>
      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="hint=false" primary="" label="取消" style="background-color:#cccccc ;color:white  " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="DeleteCheckIn" label="确定" style="background-color:#27BA69 ;color:white " />
          </td>
        </tr>
      </table>
    </mu-dialog>

		<!--提示信息-->
		<mu-toast v-if="toast" id="alertline" v-bind:message="hintMsg" @close="hideToast" />
	</div>
</template>

<style lang="less" scoped>
	@import "../../assets/theme.less";
	.plist{
		.pitem{
			display: flex;
			justify-content: space-between;
			color: #999999;
			border-bottom: 1px #ececec solid;
			.left{
				margin: auto 0;
				display: flex;
				.msg{
					margin: auto 0;
					.title{
						color: #333333;
						font-size:0.32rem;
						font-weight: 600;
					}
					.phone{
						font-size: 0.26rem;
						margin-top: 0.5em;
					}
				}
				img{
					max-height: 1.2rem;
					margin: 0.2rem;
				}
			}
			.right{
				flex-grow:1;
				text-align: right;
				margin: auto 1em;
				span{
					padding: 1px 5px;
					font-size: 0.22rem;
					border: 1px solid #ececec;
				}
				img{
					width: 0.6rem;
				}
			}
		}
	}
	.u_item{
		display: flex;
		border-bottom: 1px #ececec solid;
		padding: 1em;
		font-size: 0.26rem;
		label{
			color: #666666;
			margin: auto 0;
			text-align: center;
		}
		input{
			margin: auto 1em;
			border:none;
			outline:none;
		}
	}
	.btns{
		display: flex;
		justify-content: center;
		.mu-raised-button{
			color: #fff;
			width: 2.5rem;
			margin: 0.3rem 0.1rem;
		}
		.left{
			background-color: #ececec;
		}
		.right{
			background-color:@primaryColor;
		}
	}
</style>

<style lang="less">
	.dia_passenger{
		h3.mu-dialog-title.d_title{
			color: #333333;
			justify-content: center;
			font-size:0.32rem;
			font-weight:600;
			border-bottom:1px #ececec solid;
			padding:12px;
		}
		.mu-dialog-body {
			padding:0px;
		}
		.mu-dialog-actions{
			justify-content: space-between;
		}
		.mu-dialog-actions{
			display: none;
		}
	}
</style>


<script>
	import { mapMutations, mapGetters } from 'vuex'
	import api from '../../api/index'
	import pageTitle from '../../components/pageTitle'
	import {} from '../../utils/valid'
	import Scroll from '../../utils/loading'
	import loadListTail from '../../components/loadListTail'

	export default {
		data(){
			return{
				//添加对话框
				dialog: false,
				//提示框
				hint: false,
				toast: false,
				checkInList: [],
				//当前要删除或者编辑的信息
				currentId:'',
				hintMsg:'',
				//当前编辑框的姓名
				name:'',
				//当前编辑框的电话
				phone:'',
				refreshing: false,
				trigger: null,
				loadState:'',
				scroll:null,
				email:'',
				fromMakeOrder:false,
				maxNum:1,
				//选中索引
				selectedIndex:[],
				lastUser:''
			}
		},
		activated(){
			this.scroll.addHandler()
			if(this.g_currentOrder.checkInManInfo){
				this.fromMakeOrder = this.g_currentOrder.checkInManInfo.LastPageIsMakeOrder
				//最大可选数量为房间数减一
				this.maxNum = this.g_currentOrder.checkInManInfo.roomNum - 1
			}
			else{
				this.fromMakeOrder = false
			}

			//如果从订单页跳转来并且选中数量大于可选数量,清空已选中
			if(this.fromMakeOrder && this.selectedIndex.length > this.maxNum){
				this.checkInList.forEach((item, index , array) => {
					//已选中取消
					item.selected = false
					this.checkInList.splice(index, 1, item)
				})
				this.selectedIndex = []
			}
			if(this.lastUser != '' && this.lastUser != this.g_UserInfo.Card_no){
				this.initData()
			}
			this.lastUser = this.g_UserInfo.Card_no
			//this.GetCheckInList()
		},
		deactivated(){
			this.setCheckInManInfo()
			this.scroll.removeHandler()
		},
		mounted(){
			this.trigger = this.$el
			this.scroll = Scroll.Create(this,this.GetCheckInList,10,1)
		},
		methods:{
			...mapMutations(['setG_currentOrder']),
			initData(){
				//关闭提示信息
				this.hideToast()
				//清空选中项
				this.selectedIndex = []
				//清空显示数据
				this.checkInList = []
				//初始化本页控制数据、分页参数
				this.scroll.refresh()
			},
			open () {
				this.name = this.phone = this.email = ''
				this.dialog = true
				this.currentId = ''
			},
			close () {
				this.dialog = false
			},
			delHandler(id){
				this.hint = true
				this.currentId = id
			},
			GetCheckInList(){
				var that = this
				var params = new this.URLSearchParam()
				params.append('pageIndex', this.pageParam.index)
				params.append('pageSize', 10)
				return new Promise(function(resolve, reject) {
					that.$http.post(api.GetCheckInList(), params.toParam()).then((res) => {
						if(res.Result){
							var temp = res.Data;
							resolve(temp.length);
							that.checkInList =that.checkInList.concat(temp);
						}
						else{
							resolve(null);
							that.$router.push({ path: '/user/Login' })
						}
					}).catch(function (error) {
						reject();
					});
				})
			},
			DeleteCheckIn(){
				this.hint = false
				var params = new this.URLSearchParam()
				params.append('checkInId', this.currentId)
				this.$http.post(api.DeleteCheckIn(), params.toParam()).then((res) => {
					this.showToast(res.Message)
					if(res.Result){
						setTimeout(this.initData,1000)
					}
				})
			},
			showToast(msg) {
				this.hintMsg = msg
				this.toast = true
				if (this.toastTimer) clearTimeout(this.toastTimer)
				this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
			},
			hideToast() {
				this.toast = false
				if (this.toastTimer) clearTimeout(this.toastTimer)
			},
			InsertCheckIn(){
				if(this.name.trim() == ''){
					this.showToast('请填写姓名！')
					return
				}
				if(this.email.trim() == '' && this.phone.trim() == ''){
					this.showToast('手机号和邮箱至少填写一个！')
					return
				}
				var params = new this.URLSearchParam()
				params.append('name', this.name)
				params.append('phone', this.phone)
				params.append('email', this.email)
				if(this.currentId == ''){
					//新增
					this.$http.post(api.InsertCheckIn(), params.toParam()).then((res) => {
						this.close()
						this.showToast(res.Message)
						if(res.Result){
							setTimeout(this.initData,1000)
						}
					})
				}
				else{
					params.append('checkInId', this.currentId)
					//编辑
					this.$http.post(api.EditCheckIn(), params.toParam()).then((res) => {
						this.close()
						this.showToast(res.Message)
						if(res.Result){
							setTimeout(this.initData,1000)
						}
					})
				}

			},
			refresh () {
				this.refreshing = true
				setTimeout(() => {
					this.refreshing = false
					this.initData()
				}, 2000)
			},
			edit(checkIn){
				this.currentId = checkIn.Id
				this.name = checkIn.Name
				this.phone = checkIn.MobilePhone
				this.email = checkIn.Email
				this.dialog = true
			},
			choose(index){
				var checkIn = this.checkInList[index]
				if(checkIn.selected){
					//已选中取消
					checkIn.selected = false
					this.checkInList.splice(index, 1, checkIn)
					this.selectedIndex.forEach(function(item,ind,array){
						if(index == item){
							array.splice(ind,1)
						}
					})
				}
				else{
					//选中
					if(this.selectedIndex.length >= this.maxNum){
						//超过最大数量从最前面删除一个
						let index = this.selectedIndex[0]
						let checkIn = this.checkInList[index]
						checkIn.selected = false
						this.checkInList.splice(index, 1, checkIn)
						this.selectedIndex.splice(0,1)
					}
					checkIn.selected = true
					this.checkInList.splice(index, 1, checkIn)
					this.selectedIndex.push(index)
				}
			},
			setCheckInManInfo(){					
				if(this.fromMakeOrder){
					var currentOrder = this.g_currentOrder
					currentOrder.checkInManInfo.selected = []
					this.selectedIndex.forEach((item, index , array) => {
						var checkIn = this.checkInList[item]
						currentOrder.checkInManInfo.selected.push(checkIn)
					})
					//选中不足用空白填充
					for(var i=0;i<this.maxNum - this.selectedIndex.length;i++){
						var nullCheckIn = {
							Name:'',
							MobilePhone:'',
							Email:''
						}
						currentOrder.checkInManInfo.selected.push(nullCheckIn)
					}
					this.setG_currentOrder(currentOrder)
				}
			},
		},
		components:{
			pageTitle, loadListTail
		},
		computed:{
			...mapGetters(['g_currentOrder','g_UserInfo']),
		}
	}
</script>



// WEBPACK FOOTER //
// PassengerMsg.vue?061633ab